import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Video } from "services/cms/models/video";

export interface ResolvedVideo {
    codename: string;
    description: string;
    title: string;
    type: ContentTypeCodenames.Video;
    url: string;
    uploadDate?: string;
}

const videoResolver = (data: Video): ResolvedVideo => {
    const { description, url, title, uploadDate } = data.elements;

    return {
        codename: data.system.codename,
        description: description?.value,
        title: title?.value,
        type: ContentTypeCodenames.Video,
        url: url?.value,
        uploadDate: uploadDate?.value || undefined,
    };
};

export default videoResolver;
